import { Pill } from "@visiblethread/react-components";
import DocumentCounts from "components/DocumentCounts";
import { DOCUMENT_COUNTS_ORDER } from "components/OpportunityToProposal/constants";
import React from "react";

import {
  HAS_PROPOSAL_COLOR,
  HAS_PROPOSAL_LABEL,
  NO_PROPOSAL_COLOR,
  NO_PROPOSAL_LABEL,
} from "./constants";
import styles from "./OpportunityToProposalModal.module.scss";

export const columns = [
  {
    header: "Opportunity",
    accessorKey: "opportunityName",
    id: "opportunityName",
    enableSorting: false,
    cell: ({ row }) => (
      <span
        className={styles.opportunityToProposalModal__name}
        title={row.original.opportunityName}
      >
        {row.original.opportunityName}
      </span>
    ),
  },
  {
    header: "Analysis",
    accessorKey: "documentCount",
    id: "analysis",
    enableSorting: false,
    cell: ({ row }) => {
      const opp = row.original;
      return (
        <DocumentCounts
          documentCount={opp.documentCount}
          shreddingCount={opp.shredCount}
          researchCount={opp.researchDocCount}
          amendmentCount={opp.compareDocCount}
          hasTechnicalAlignment={opp.technicalAlignmentCount > 0}
          order={DOCUMENT_COUNTS_ORDER}
        />
      );
    },
  },
  {
    header: "Proposal",
    accessorKey: "hasProposal",
    id: "hasProposal",
    enableSorting: true,
    cell: ({ row }) =>
      row.original.hasProposal ? (
        <Pill color={HAS_PROPOSAL_COLOR} label={HAS_PROPOSAL_LABEL} />
      ) : (
        <Pill color={NO_PROPOSAL_COLOR} label={NO_PROPOSAL_LABEL} />
      ),
  },
];
